import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Confirmation from "./component";
import { downloadAssessmentResult, updateConfimation } from "./actions";
import { GetUserById, isGuestOrPremiumUser } from "../settings/actions";

import {
  getAssessmentAttemptByUserId,
  getInsightfulContent,
  sendToFriendReportOnEmail,
} from "../dashboard/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      getInsightfulContentConnect: getInsightfulContent,
      getUserByIdConnect: GetUserById,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,
    },

    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);
